import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let SchoolServiceController = {
    getAllServiceRegistered: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school-service/student/all-service-registered`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getAllServiceRegisteredByStudent: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/school-service/student/all-service-registered-by-student`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/student/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
}

export default SchoolServiceController
